import { categoryList } from '@/mocks/news';

type CategoryFilterProps = {
  active: string;
  counts: Record<string, number>;
  onChange: (id: string) => void;
};

export default function CategoryFilter({ active, counts, onChange }: CategoryFilterProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {categoryList.map((cat) => {
        const isActive = active === cat.id;
        return (
          <button
            key={cat.id}
            type="button"
            onClick={() => onChange(cat.id)}
            className={`flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border px-4 py-2 text-sm font-label transition-colors ${
              isActive
                ? 'border-primary-500 bg-primary-500 text-background-50'
                : 'border-background-300 bg-background-100 text-foreground-600 hover:border-primary-400 hover:text-foreground-950'
            }`}
          >
            <i className={`${cat.icon} text-base`} />
            {cat.name}
            <span
              className={`rounded-full px-1.5 text-[11px] ${
                isActive ? 'bg-background-50/20 text-background-50' : 'bg-background-200 text-foreground-500'
              }`}
            >
              {counts[cat.id] ?? 0}
            </span>
          </button>
        );
      })}
    </div>
  );
}